import type { QueryClient } from "@tanstack/react-query";

import { RECENT_CONVERSATIONS_KEY } from "@/api/chat/conversationListKeys";

import { CHAT_HISTORY_KEY } from "../history/chatHistoryKeys";

export async function invalidateConversationLists(
    queryClient: QueryClient,
    { includeRecent = true }: { includeRecent?: boolean } = {}
) {
    const queryKeys = [
        [CHAT_HISTORY_KEY],
        ...(includeRecent ? [RECENT_CONVERSATIONS_KEY] : []),
    ];
    await Promise.all(
        queryKeys.map((queryKey) => queryClient.cancelQueries({ queryKey }))
    );
    for (const queryKey of queryKeys) {
        void queryClient.invalidateQueries({ queryKey });
    }
}
